export const BLOCKED = new Set(["waiting_human", "awaiting_approval"]);
